import React from 'react';
import {
  AlgorithmButton,
  InputField,
  RadioButton,
  TextBox,
  AlgorithmCheckbox,
  MultiSelect,
  AlgorithmAccordion } from '../algorithm_components';


const getComponent = (item, changeData, onClickMultiSelectButton, navigation='none') => {

  switch (item.type) {
    case 'text':
      return <TextBox
        componentBlock={item}
        contentData={item.content.value}
        title={item.content.title.replace('<a', '<a target="_blank" ')}
        navigation={navigation}
      />;

    case 'input':
      return <InputField
        componentBlock={item}
        placeholder={item.content.title.replace(/(\<(\/?[^>]+)>)/g, '')}
        navigation={navigation}
      />;

    case 'radiobutton':
      return <RadioButton
        componentBlock={item}
        contentData={item.content.value}
        id={item.id}
        changeData={changeData}
        title={item.content.title}
        navigation={navigation}
      />;

    case 'button':
      return <AlgorithmButton
        contentData={item.content.value}
        id={item.id}
        changeData={changeData}
        componentBlock={item}
        title={item.content.title.replace(/(\<(\/?[^>]+)>)/g, '')}
        navigation={navigation}
      />;

    case 'checkbox':
      return <AlgorithmCheckbox
        componentBlock={item}
        contentData={item.content.value}
        id={item.id}
        changeData={changeData}
        title={item.content.title.replace(/(\<(\/?[^>]+)>)/g, '')}
        navigation={navigation}
      />;
    case 'multiSelect':
      return <MultiSelect
        componentBlock={item}
        contentData={item.content.value}
        onClickMultiSelectButton={onClickMultiSelectButton}
        id={item.id}
        changeData={changeData}
        title={item.content.title.replace(/(\<(\/?[^>]+)>)/g, '')}
        navigation={navigation}
      />;
    case 'accordion':
      return <AlgorithmAccordion
        componentBlock={item}
        contentData={item.content.value}
        id={item.id}
        changeData={changeData}
        title={item.content.title.replace('<a', '<a target="_blank" ')}
        navigation={navigation}
      />
  }
};

export {
  getComponent,
}
